import type { Permissions } from 'api/types';

import type { Item } from '../types';

export const isItemHidden = (item: Item, permissions: Permissions) =>
  item?.hide || (item.permission && !permissions.has(item.permission));
